import { motion } from "framer-motion";
import { SectionHeading, revealProps, Eyebrow } from "@/components/lux";

export default function AboutSection({ settings = {} }) {
  const portrait = settings.about_portrait ||
    "https://images.unsplash.com/photo-1622750657128-8d1db9f1ba06?crop=entropy&cs=srgb&fm=jpg&q=85";

  return (
    <section id="about" className="relative py-24 sm:py-32 bg-[#090A0F]" data-testid="about-section">
      <div className="mx-auto max-w-[1300px] px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div {...revealProps()} className="relative">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
            <img src={portrait} alt="Luhai — Bahamas photographer portrait" className="w-full h-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          </div>
          <div className="absolute -bottom-5 -right-2 sm:-right-5 bg-[#02AACF] rounded-xl px-5 py-4 rotate-[-3deg]">
            <p className="font-mono2 text-[10px] tracking-[0.2em] text-white/80 uppercase">Based in</p>
            <p className="font-display font-bold text-white text-lg">Nassau, Bahamas</p>
          </div>
        </motion.div>

        <motion.div {...revealProps(0.15)}>
          <SectionHeading eyebrow="About" title="I'm Luhai." />
          <div className="space-y-4 mt-6 text-[#94A3B8] text-base sm:text-lg leading-relaxed">
            <p>I'm a Bahamas-based photographer focused on capturing real moments, real energy and real people.</p>
            <p>My work spans lifestyle photography, portraits, brands, events and creative visual storytelling.</p>
            <p>I don't just take photos — I create imagery designed to feel <span className="text-white">authentic, memorable and intentional</span>. My goal is to create visuals that make people and brands stand out.</p>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-10">
            {[["2+", "Years shooting"], ["500+", "Sessions"], ["100%", "Real energy"]].map(([n, l]) => (
              <div key={l} className="border-l border-[#02AACF]/40 pl-4">
                <p className="font-display font-bold text-3xl text-white">{n}</p>
                <p className="text-xs text-[#64748B] mt-1">{l}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
